import { render } from "./IntegralDetail.vue?vue&type=template&id=a144542c&scoped=true&ts=true"
import script from "./IntegralDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntegralDetail.vue?vue&type=script&setup=true&lang=ts"

import "./IntegralDetail.vue?vue&type=style&index=0&id=a144542c&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a144542c"],['__file',"src/views/me/IntegralDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a144542c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a144542c', __exports__)) {
    console.log('reload')
    api.reload('a144542c', __exports__)
  }
  
  module.hot.accept("./IntegralDetail.vue?vue&type=template&id=a144542c&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a144542c', render)
  })

}


export default __exports__